import { render, staticRenderFns } from "./RestaurantDetailsBlock.vue?vue&type=template&id=2653a83c&scoped=true&"
import script from "./RestaurantDetailsBlock.vue?vue&type=script&lang=js&"
export * from "./RestaurantDetailsBlock.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantDetailsBlock.vue?vue&type=style&index=0&id=2653a83c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2653a83c",
  null
  
)

export default component.exports